import { api } from 'app/utils/api/helpers'

/**
 * Search for PMS properties
 * @param {string} teamGUID - The team GUID
 * @param {string} searchQuery - The search query
 * @returns {Promise<object>} - The API response
 */
export const searchPMSProperties = async (teamGUID, searchQuery) => {
  if (!teamGUID || !searchQuery?.trim()) {
    return { data: [] }
  }

  const response = await api.get(`/sm/team/${teamGUID}/pmsproperty`, {
    params: {
      address: searchQuery.trim(),
    },
  })

  // The API response format should be { data: [...] }
  // If the API returns the array directly, wrap it in data property
  if (Array.isArray(response.data)) {
    return { data: response.data }
  }

  return response.data
}
